$ = require 'jquery'
AnnouncementsList = require 'models/collections/announcements-list'
Util = require 'lib/util'
_ = require 'underscore'

module.exports = Announcements = new AnnouncementsList [],
  requiresLogin: true
  dataUrl: '/announcements'



// WEBPACK FOOTER //
// ./app/scripts/models/announcements.coffee